common.View.create('canvas.blocks.modules.contentPromotionSlider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: false,
                nav: true,
                navText : [
                    "<div class=\"bg-palette-pink text-3xl text-white px-4 py-2 rounded inline-flex hover:bg-white hover:text-palette-pink transition mx-1\"><i class=\"far fa-chevron-left\"></i></div>",
                    "<div class=\"bg-palette-pink text-3xl text-white px-4 py-2 rounded inline-flex hover:bg-white hover:text-palette-pink transition mx-1\"><i class=\"far fa-chevron-right\"></i></div>"
                ],
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                responsive: {
                    0: {
                        items: 1.5,
                        margin: 20
                    },
                    640: {
                        items: 2.5,
                        margin: 25
                    },
                    1024: {
                        items: 3,
                        margin: 50
                    }
                }
            });

    }
});
